// Self-hosted font files (no external requests at build or runtime - the
// glyphs are bundled with the app, same principle as next/font but with
// full control over exactly which weights ship).
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/playfair-display/600.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/pacifico/400.css";
import "@fontsource/oswald/500.css";
import "@fontsource/oswald/700.css";

export type FontCategory = "sans" | "serif" | "mono" | "script" | "display";

export interface FontOption {
  id: string;
  label: string;
  /** CSS font-family value usable both inline and for canvas measurement */
  family: string;
  category: FontCategory;
  weight: number;
}

export const fontOptions: FontOption[] = [
  {
    id: "arial",
    label: "Arial",
    family: "Arial, Helvetica, sans-serif",
    category: "sans",
    weight: 400,
  },
  {
    id: "verdana",
    label: "Verdana",
    family: "Verdana, Geneva, sans-serif",
    category: "sans",
    weight: 400,
  },
  {
    id: "times",
    label: "Times New Roman",
    family: '"Times New Roman", Times, serif',
    category: "serif",
    weight: 400,
  },
  {
    id: "courier",
    label: "Courier New",
    family: '"Courier New", Courier, monospace',
    category: "mono",
    weight: 400,
  },
  {
    id: "montserrat",
    label: "Montserrat",
    family: '"Montserrat", sans-serif',
    category: "sans",
    weight: 700,
  },
  {
    id: "playfair",
    label: "Playfair Display",
    family: '"Playfair Display", serif',
    category: "serif",
    weight: 700,
  },
  {
    id: "oswald",
    label: "Oswald",
    family: '"Oswald", sans-serif',
    category: "display",
    weight: 700,
  },
  {
    id: "pacifico",
    label: "Pacifico",
    family: '"Pacifico", cursive',
    category: "script",
    weight: 400,
  },
];

export const defaultFontId = "montserrat";

export function getFontOption(id: string): FontOption {
  return fontOptions.find((f) => f.id === id) ?? fontOptions[0];
}
